module.exports = __webpack_public_path__ + "media/images/countrysquared/ck-950f9c40dcfd5bb5485468d9a1136932.svg";